import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { PessoaFisicaDTO } from 'app/model/dtos/grl/pessoa-fisica.dto';
import { PessoaFisicaService } from 'app/services/grl/pessoa-fisica.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { DialogFactory } from 'sol-tools-ts/dist';

@Component({
  selector: 'text-cpf',
  templateUrl: './text-cpf.component.html',
  styleUrls: ['./text-cpf.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextCpfComponent implements OnInit {

  formGroup: FormGroup;
  @Output() resultPessoaFisica: EventEmitter<PessoaFisicaDTO> = new EventEmitter<PessoaFisicaDTO>();

  constructor(
    private _controlContainer: ControlContainer,
    private _pessoaFisicaService: PessoaFisicaService,
    private _dialogFactory: DialogFactory
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
  }

  async onChangeNrCpf($event) {
    let nrCpf = $event.currentTarget.value.replace(/\.|-/gm, '');
    if (!nrCpf) return;

    let pessoaFisicaDTO: PessoaFisicaDTO = await this._pessoaFisicaService.getPessoaByCPF(nrCpf);
    if (!pessoaFisicaDTO || pessoaFisicaDTO.cdPessoa == undefined) {
      this.formGroup.reset();
      this.formGroup.get("nrCpf").setValue(nrCpf);
      this.resultPessoaFisica.emit(pessoaFisicaDTO);
  
      return this._dialogFactory.snack('Pessoa não localizada, será necessário cadastrá-la', 'OK', DialogFactory.SNACK_WARNING, { duration: 10000 });
    }

    this.formGroup.patchValue(pessoaFisicaDTO);
    this.formGroup.get('pessoa').patchValue(pessoaFisicaDTO.pessoaDTO);
    this.resultPessoaFisica.emit(pessoaFisicaDTO);
  }
}
